import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Text } from "@/components/Text";
import { sendAdminInvitationToNotInvited } from "@/data/admin-invitations";
import { sendConsultantInvitationToNotInvited } from "@/data/consultant-invitations";
import { sendManagerInvitationToNotInvited } from "@/data/manager-invitations";
import { TUserRole } from "@/data/session";
import { useCompanyContext } from "@/hooks/User";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { useToasts } from "@/views/components/Toast/useToasts";

interface ISendInvitationButtonProps extends IConsultantProfileSectionProps {
  baseClass?: string;
}

const sendInvitationMap: Record<TUserRole, any> = {
  CONSULTANT: sendConsultantInvitationToNotInvited,
  MANAGER: sendManagerInvitationToNotInvited,
  ADMIN: sendAdminInvitationToNotInvited,
};

export const SendInvitationButton: FC<ISendInvitationButtonProps> = memo(
  ({ record, onUpdate, baseClass = "consultant-profile" }) => {
    const Company = useCompanyContext();
    const { addToast } = useToasts();
    const { t } = useTranslation(["session", "common"]);

    const sendInvitation = async () => {
      try {
        const invitation = await sendInvitationMap[record.companyRole!](
          {
            companyId: Company.id,
          },
          record,
        );
        addToast({ text: t("CONSULTANT_PROFILES.DETAIL.SETTINGS.ACTION_RESEND_SUCCESS"), type: "success" });
        onUpdate?.(invitation.consultantProfile);
      } catch (e) {
        addToast({ text: t("common:ERROR_MESSAGES.GENERAL"), type: "warning" });
      }
    };

    return (
      <Button
        onClick={sendInvitation}
        icon="messages"
        variant="link"
        className={`${baseClass}__send-invitation-button`}>
        <Text>{t("CONSULTANT_PROFILES.DETAIL.ACTIONS_SEND_INVITATION")}</Text>
      </Button>
    );
  },
);
